import styled from "styled-components/macro";
import { lightGrey } from "../../../../constants/colors";
import { BREAKPOINT_MOBILE } from "../../../../constants/constants";

export const PERCENT_BAR_HEIGHT_PX = 22;
export const MOBILE_PERCENT_BAR_HEIGHT_PX = 16;

export type PercentBarStylesProps = {
  $width: number;
  $color: string;
  $hideBorder: boolean;
  $roundLeft?: boolean;
  $roundRight?: boolean;
};

const PercentBarStyles = styled.div<PercentBarStylesProps>`
  display: flex;
  width: inherit;
  .percent-bar {
    position: relative;
    height: ${PERCENT_BAR_HEIGHT_PX}px;
    display: flex;
    width: inherit;
    border: ${props => (props.$hideBorder ? "" : "1px solid" + lightGrey)};
  }

  .filler {
    height: 100%;
    width: ${props => props.$width}%;
    border-right: 1px solid ${lightGrey};
    border: ${props => (props.$hideBorder ? "1px solid" + lightGrey : "")};
  }

  .noLineFill {
    background: ${props => props.$color};
  }

  .lineFill {
    background-image: linear-gradient(
      to left,
      ${props => props.$color} 50%,
      transparent 50%
    );
    background-size: 4px 100%;
  }

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    .percent-bar {
      height: ${MOBILE_PERCENT_BAR_HEIGHT_PX}px;
    }
  }
`;

export default function PercentBar({
  percent,
  color,
  shouldFillWithLines,
  hideBorder,
}: {
  percent: string | number;
  color: string;
  shouldFillWithLines: boolean;
  hideBorder: boolean;
}) {
  let percentDisplay = String(percent);
  // handle NaN
  if (isNaN(Number(percent))) {
    percentDisplay = "0";
    // If value is infinity, need to fill bar
  } else if (!isFinite(Number(percent))) {
    percentDisplay = "100";
  }
  return (
    <PercentBarStyles
      $width={Math.abs(parseInt(percentDisplay, 10))}
      $color={color}
      $hideBorder={hideBorder}
    >
      <div className="percent-bar">
        <div
          className={`filler ${
            shouldFillWithLines ? "lineFill" : "noLineFill"
          }`}
        />
      </div>
    </PercentBarStyles>
  );
}
